/* eslint-disable */
export const config = {
  appConfig: {
  },
};
